import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AlumniService } from '../alumni.service';
import { AlumniReportsViewPart } from './reports/alumni-reports.part';
import { AlumniServiceViewPart } from './services/alumni-service.part';
@Component({
	selector: 'alumni-views-part',
	standalone: true,
	imports: [
		AlumniReportsViewPart,
		AlumniServiceViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './alumni-views.part.html',
})
export class AlumniViewsPart implements OnInit {

	public service = inject(AlumniService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}
